/* tslint:disable */ /* eslint-disable */
import * as Types from '../../../models/generated/index';

import { gql } from '@apollo/client';
import { SkinnyScheduledReminderFragmentFragmentDoc } from '../../../models/generated/SkinnyScheduledReminderFragment';
import { SkinnyUserAttributeValueFragmentFragmentDoc } from '../../../models/generated/SkinnyUserAttributeValueFragment';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ScheduledSurveyWithCommentsQueryVariables = Types.Exact<{
  scheduledSurveyId: Types.Scalars['Int'];
  processingStatuses?: Types.InputMaybe<Array<Types.Processing_Status> | Types.Processing_Status>;
  skip?: Types.InputMaybe<Types.Scalars['Int']>;
  limit?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type ScheduledSurveyWithCommentsQuery = { scheduledSurvey?: { id: number, scheduledId: number, recipientCommentsAwaitingAnswerCount: number, recipientCommentsWithDraftedAnswerCount: number, recipientCommentsWithCurrentFiltersCount: number, status: { absolute: Types.Scheduled_Survey_Status, local: Types.Scheduled_Survey_Status }, beginAt: { local: string, earliest?: string | undefined, latest?: string | undefined }, endAt: { local: string, earliest?: string | undefined, latest?: string | undefined }, survey: { id: number, name: string, theme: { id: number, icon: string, name: string, description: string, color: string } }, scheduledReminders: Array<{ remind_hours_before_end: number, is_editable: boolean }>, recipientComments: Array<{ id: number, comment: string, validatedAt?: string | undefined, publishedAt?: string | undefined, isAnonymous: boolean, objectId: number, objectType: Types.CommentObjectType, commentTranslations: Array<{ wording: string, language: { code: string, translatedLabel: string, localizedLabel: string } }>, creator?: { id: number, timezone: string, displayName: string, language: { code: string, translatedLabel: string, localizedLabel: string } } | undefined, creatorAttributeValue?: { name: string, value: string, valueId: number, attributeId: number, isMainHierarchyHead: boolean, parent?: { attributeId: number, valueId: number } | undefined, children: Array<{ attributeId: number, valueId: number }> } | undefined, context: { scheduledSurvey?: { schedulingId: number, beginAt: { local: string }, endAt: { local: string }, status: { absolute: Types.Scheduled_Survey_Status, local: Types.Scheduled_Survey_Status }, survey: { id: number, name: string, theme: { id: number, color: string, name: string, icon: string } } } | undefined, question?: { id: number, name: string, type: Types.QuestionType } | undefined, response?: { id: number, choice?: { id: number, name: string, icon: string, maxSatisfactionValue: number, satisfactionValue: number } | undefined } | undefined }, answers: Array<{ id: number, comment: string, validatedAt?: string | undefined, publishedAt?: string | undefined, isAnonymous: boolean, commentTranslations: Array<{ wording: string, language: { code: string, translatedLabel: string, localizedLabel: string } }>, creator?: { id: number, timezone: string, displayName: string, language: { code: string, translatedLabel: string, localizedLabel: string } } | undefined }> }> } | undefined };


export const ScheduledSurveyWithCommentsDocument = gql`
    query ScheduledSurveyWithComments($scheduledSurveyId: Int!, $processingStatuses: [Processing_status!], $skip: Int, $limit: Int) {
  scheduledSurvey: scheduled_survey(scheduled_survey_id: $scheduledSurveyId) {
    id
    scheduledId: id
    status {
      absolute
      local
    }
    beginAt: begin_at {
      local
      earliest
      latest
    }
    endAt: end_at {
      local
      earliest
      latest
    }
    survey {
      id
      name
      theme {
        id
        icon
        name
        description
        color
      }
    }
    scheduledReminders: scheduled_reminders {
      ...SkinnyScheduledReminderFragment
    }
    recipientCommentsAwaitingAnswerCount: number_of_recipient_comments(processing_status: awaiting)
    recipientCommentsWithDraftedAnswerCount: number_of_recipient_comments(processing_status: draft)
    recipientCommentsWithCurrentFiltersCount: number_of_recipient_comments(processing_status: $processingStatuses)
    recipientComments: recipient_comments(processing_status: $processingStatuses, limit: $limit, skip: $skip) {
      id
      comment
      commentTranslations: comment_translations {
        wording
        language {
          code
          translatedLabel: translated_label
          localizedLabel: localized_label
        }
      }
      validatedAt: validated_at
      publishedAt: published_at
      isAnonymous: is_anonymous
      creator {
        id
        displayName: display_name
        timezone
        language {
          code
          translatedLabel: translated_label
          localizedLabel: localized_label
        }
      }
      creatorAttributeValue: author_hierarchal_attribute_value {
        ...SkinnyUserAttributeValueFragment
      }
      objectId: object_id
      objectType: object_type
      context {
        scheduledSurvey: scheduled_survey {
          schedulingId: id
          beginAt: begin_at {
            local
          }
          endAt: end_at {
            local
          }
          status {
            absolute
            local
          }
          survey {
            id
            name
            theme {
              id
              color
              name
              icon
            }
          }
        }
        question {
          id
          name
          type
        }
        response {
          id
          choice {
            icon: icon_url
            id
            maxSatisfactionValue: max_satisfaction_value
            name
            satisfactionValue: satisfaction_value
          }
        }
      }
      answers: responses {
        id
        validatedAt: validated_at
        publishedAt: published_at
        comment
        commentTranslations: comment_translations {
          wording
          language {
            code
            translatedLabel: translated_label
            localizedLabel: localized_label
          }
        }
        creator {
          id
          displayName: display_name
          timezone
          language {
            code
            translatedLabel: translated_label
            localizedLabel: localized_label
          }
        }
        isAnonymous: is_anonymous
      }
    }
  }
}
    ${SkinnyScheduledReminderFragmentFragmentDoc}
${SkinnyUserAttributeValueFragmentFragmentDoc}`;

/**
 * __useScheduledSurveyWithCommentsQuery__
 *
 * To run a query within a React component, call `useScheduledSurveyWithCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduledSurveyWithCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduledSurveyWithCommentsQuery({
 *   variables: {
 *      scheduledSurveyId: // value for 'scheduledSurveyId'
 *      processingStatuses: // value for 'processingStatuses'
 *      skip: // value for 'skip'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useScheduledSurveyWithCommentsQuery(baseOptions: Apollo.QueryHookOptions<ScheduledSurveyWithCommentsQuery, ScheduledSurveyWithCommentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScheduledSurveyWithCommentsQuery, ScheduledSurveyWithCommentsQueryVariables>(ScheduledSurveyWithCommentsDocument, options);
      }
export function useScheduledSurveyWithCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScheduledSurveyWithCommentsQuery, ScheduledSurveyWithCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScheduledSurveyWithCommentsQuery, ScheduledSurveyWithCommentsQueryVariables>(ScheduledSurveyWithCommentsDocument, options);
        }
export type ScheduledSurveyWithCommentsQueryHookResult = ReturnType<typeof useScheduledSurveyWithCommentsQuery>;
export type ScheduledSurveyWithCommentsLazyQueryHookResult = ReturnType<typeof useScheduledSurveyWithCommentsLazyQuery>;
export type ScheduledSurveyWithCommentsQueryResult = Apollo.QueryResult<ScheduledSurveyWithCommentsQuery, ScheduledSurveyWithCommentsQueryVariables>;